import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { NumberishId, Polygon } from "../../../model/type";
import { PatchBodyType } from "../PatchBodyType";
import { UpdatableFields } from "../../../action/updateManyAvailabilities";

export class Endpoint extends ApiEndpoint {
    public patch = (offerId: string, body: PatchBody): Promise<AxiosResponse<void|{ deletedCount: number }>> => {
        return this.connection.patch(`/offers/${offerId}/medium-availabilities`, body);
    }
}

export type PatchBody =
    PatchBodyType<'DELETE_SOFTLY', {
        availabilityIds?: NumberishId[],
        customAreasInner?: Polygon[],
        customAreasOuter?: Polygon[]
    }>
    | PatchBodyType<'UPDATE', { availabilityIds: NumberishId[], fields: UpdatableFields }>
